module.exports = __webpack_public_path__ + "img/OVCA_Mono.Macro.80a77263.png";